import PageSpy from '@huolala-tech/page-spy-browser';
import RRWebPlugin from '@huolala-tech/page-spy-plugin-rrweb';
import DataHarborPlugin from '@huolala-tech/page-spy-plugin-data-harbor';

import userInfoStore from '@/store/user.store';

PageSpy.registerPlugin(new RRWebPlugin());
const harbor = new DataHarborPlugin();
PageSpy.registerPlugin(harbor);

window.__uploadLog__ = async () => {
  const url = await harbor.onOfflineLog('upload');
  console.log(url);
}

let pageSpy: PageSpy | null = null;

if (__IS_BUILD_IN_CI__) {
  userInfoStore.subscribe((userInfo) => {
    if (pageSpy) {
      if (userInfo.mobile) {
        pageSpy.updateRoomInfo({
          title: `${userInfo.displayName}-${userInfo.mobile}` || '--',
        });
      }
    }
  });

  const initPageSpy = () => {
    // 正式环境不初始化pagespy
    if(import.meta.env.VITE_SENTRY_ENV === 'production') return;
    const version = __APP_VERSION__;
    try {
      pageSpy = new PageSpy({
        clientOrigin: 'https://lastos-pagespy.maxhub.com',
        api: 'lastos-pagespy.maxhub.com',
        autoRender: false,
        project: navigator.userAgent.includes('Electron') ? `${version}-Electron` : `${version}-Web`,
        title: `${location.pathname}${location.search}`,
        logo: '/favicon.png',
        enableSSL: true,
      });
    } catch (err) {
      console.error(err);
    }
  }

  initPageSpy();
}

export {
  pageSpy,
  harbor,
};